import { PersonalSettingsPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { isFactorialIdUser } from 'modules/core/lib/factorialIdTokenRefresh'
import { useQuery } from 'modules/core/hooks/useQuery'

import { MFASettings as FactorialIDMFASettings } from 'modules/factorial_id/components/MFASettings'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import ExternalCalendar from './ExternalCalendar'
import { default as LegacyMFASettings } from './MFASettings'
import AnalyticsConsentSettings from './analyticsConsentSettings'
import DiscoverabilityWidgetSettings from './discoverabilityWidgetSettings'
import PasswordSettings from './passwordSettings'
import PersonalSettings from './personalSettings'

const Settings = () => {
  const { access, company } = useCurrentSession()
  const { data } = useQuery(PersonalSettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const flags = new Set(
    data?.features.enabledFeatures.nodes.map((flag) => (flag.enabled ? flag.name : undefined))
  )
  const factorialId = isFactorialIdUser()
  const canShowExternalCalendar = flags.has('ats_interview_scheduling')
  const canManageDiscoverabilityWidget = data?.apiCore?._policies.manageDiscoverabilityWidget.can
  const doNotTrack = flags.has('do_not_track')
  const shouldShowAnalyticsConsent = typeof access.analyticsConsent === 'boolean' && doNotTrack

  const MFASettings = factorialId ? FactorialIDMFASettings : LegacyMFASettings

  return (
    <ResponsivePage.Body variant="narrow" showHeader={false}>
      <PersonalSettings />
      <PasswordSettings />
      <MFASettings />
      {canShowExternalCalendar && <ExternalCalendar />}
      {shouldShowAnalyticsConsent && <AnalyticsConsentSettings />}
      {canManageDiscoverabilityWidget && <DiscoverabilityWidgetSettings />}
    </ResponsivePage.Body>
  )
}

export default observer(Settings)
